export const navLinks = [
  { label: '首页', href: '/' },
  { label: '游戏分类', href: '/category/all' },
  { label: '攻略资讯', href: '/article/1' },
  { label: '关于我们', href: '/about' },
];

export const heroData = {
  headline: '快速开户，即刻畅玩',
  subheadline: '2pg·com 登录注册流程简单快捷，手机/邮箱一键注册，安全加密保障账户安全',
  ctaPrimary: '立即注册',
  ctaSecondary: '已有账号？立即登录',
};

export const features = [
  {
    icon: 'ri-flashlight-line',
    title: '一键快速注册',
    description: '支持手机号与邮箱两种方式，30秒完成开户，无需复杂验证流程，立即开启游戏之旅。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全加密保障',
    description: '采用业界领先的 SSL/TLS 加密技术，多重身份验证机制，全面守护您的账户与资金安全。',
  },
  {
    icon: 'ri-gamepad-line',
    title: '海量游戏资源',
    description: '涵盖热门棋牌、电子竞技、真人娱乐等多种游戏类型，持续更新，总有您喜欢的玩法。',
  },
  {
    icon: 'ri-gift-line',
    title: '专属新人福利',
    description: '注册即享丰厚新人礼包，首充优惠、每日签到奖励、VIP等级特权等您来领取。',
  },
];

export const registerSteps = [
  {
    step: 1,
    title: '填写基本信息',
    description: '输入手机号或邮箱地址，设置安全的登录密码',
  },
  {
    step: 2,
    title: '完成身份验证',
    description: '接收验证码并完成验证，确保账户由本人操作',
  },
  {
    step: 3,
    title: '领取新人福利',
    description: '注册成功即可领取专属新人礼包，开启畅玩之旅',
  },
];

export const categories = [
  {
    id: 'chess',
    name: '棋牌游戏',
    icon: 'ri-bard-line',
    description: '经典棋牌玩法，斗地主、麻将、牛牛等热门项目',
    imageUrl: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20chess%20and%20mahjong%20tiles%20on%20a%20warm%20wooden%20table%20with%20soft%20ambient%20lighting%2C%20elegant%20game%20room%20atmosphere%2C%20rich%20textures%2C%20professional%20product%20photography%20with%20shallow%20depth%20of%20field&width=800&height=400&seq=cat-chess&orientation=landscape',
  },
  {
    id: 'esports',
    name: '电子竞技',
    icon: 'ri-computer-line',
    description: '热门电竞游戏竞猜，LOL、DOTA2、CS2等顶级赛事',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20esports%20gaming%20arena%20with%20colorful%20LED%20lights%20and%20gaming%20chairs%2C%20futuristic%20competitive%20gaming%20environment%2C%20dark%20atmosphere%20with%20neon%20accents%2C%20cinematic%20lighting&width=800&height=400&seq=cat-esports&orientation=landscape',
  },
  {
    id: 'live',
    name: '真人娱乐',
    icon: 'ri-live-line',
    description: '真人荷官在线发牌，实时互动，身临其境的游戏体验',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20live%20casino%20studio%20with%20professional%20dealers%20at%20gaming%20tables%2C%20sophisticated%20interior%20with%20warm%20golden%20lighting%2C%20high-end%20entertainment%20venue%20aesthetic%2C%20luxurious%20atmosphere&width=800&height=400&seq=cat-live&orientation=landscape',
  },
  {
    id: 'slot',
    name: '电子游艺',
    icon: 'ri-slideshow-2-line',
    description: '丰富多样的老虎机与电子游戏，高清画质，玩法新颖有趣',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20digital%20slot%20machine%20interface%20with%20vibrant%20colors%20and%20dynamic%20animations%2C%20futuristic%20gaming%20display%20with%20glowing%20elements%2C%20dark%20background%20with%20colorful%20illuminated%20details%2C%20high-tech%20entertainment%20aesthetic&width=800&height=400&seq=cat-slot&orientation=landscape',
  },
  {
    id: 'sport',
    name: '体育赛事',
    icon: 'ri-football-line',
    description: '足球、篮球、网球等全球体育赛事竞猜，实时赔率更新',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20with%20dramatic%20stadium%20lighting%20and%20action%20atmosphere%2C%20professional%20sports%20photography%20style%2C%20wide%20angle%20view%20with%20energy%20and%20excitement%2C%20warm%20golden%20hour%20tones&width=800&height=400&seq=cat-sport&orientation=landscape',
  },
  {
    id: 'fishing',
    name: '捕鱼游戏',
    icon: 'ri-anchor-line',
    description: '精美海底世界场景，多人同台竞技，畅快捕鱼体验',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20underwater%20ocean%20scene%20with%20colorful%20tropical%20fish%20and%20coral%20reef%2C%20crystal%20clear%20water%20with%20sunlight%20rays%20streaming%20through%2C%20vibrant%20marine%20life%2C%20serene%20and%20magical%20aquatic%20atmosphere&width=800&height=400&seq=cat-fishing&orientation=landscape',
  },
];

export const trustFeatures = [
  {
    icon: 'ri-lock-line',
    title: '数据加密传输',
    description: '采用256位SSL/TLS加密协议，所有数据传输全程加密，防止信息泄露。',
  },
  {
    icon: 'ri-user-star-line',
    title: '千万用户信赖',
    description: '平台累计服务超过千万用户，稳定运营多年，口碑值得信赖。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '7×24小时客服',
    description: '全天候在线客服支持，随时为您解答疑问，处理账户相关问题。',
  },
  {
    icon: 'ri-bank-card-line',
    title: '资金安全托管',
    description: '用户资金独立托管于持牌金融机构，受严格监管，存取快捷有保障。',
  },
];

export const articles = [
  {
    id: 1,
    title: '2pg·com 新用户注册完整指南：从开户到畅玩只需三步',
    excerpt: '本文将详细介绍2pg·com平台的完整注册流程，包括手机/邮箱注册方式选择、身份验证注意事项、以及如何快速领取新人专属福利，帮助您轻松完成开户。',
    category: '平台指南',
    date: '2026-08-01',
    readTime: '5分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20smartphone%20showing%20registration%20form%20interface%20on%20screen%2C%20clean%20white%20desk%20setup%20with%20warm%20ambient%20lighting%2C%20professional%20tech%20lifestyle%20photography%2C%20soft%20shadows%20and%20elegant%20composition&width=800&height=480&seq=article-register-guide&orientation=landscape',
  },
  {
    id: 2,
    title: '2026年热门棋牌游戏推荐：2pg平台精选玩法大盘点',
    excerpt: '为您盘点2pg平台上最受欢迎的棋牌游戏类型，包括斗地主技巧攻略、麻将高级打法解析、以及各类棋牌游戏的新手入门指南，助您快速上手。',
    category: '游戏攻略',
    date: '2026-07-28',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20arrangement%20of%20playing%20cards%20and%20mahjong%20tiles%20on%20a%20dark%20wooden%20table%2C%20warm%20golden%20lighting%20from%20above%2C%20rich%20gaming%20atmosphere%2C%20luxurious%20game%20room%20aesthetic%2C%20professional%20still%20life%20photography&width=800&height=480&seq=article-game-guide&orientation=landscape',
  },
  {
    id: 3,
    title: '账户安全不容忽视：2pg·com 安全防护体系全面解读',
    excerpt: '深入了解2pg平台的多层安全防护体系，从登录验证、交易加密到异常行为监测，全面了解平台如何保障您的账户与资金安全。',
    category: '平台资讯',
    date: '2026-07-20',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20security%20concept%20with%20glowing%20shield%20icon%20and%20encrypted%20data%20streams%2C%20dark%20futuristic%20background%20with%20cyber%20elements%2C%20professional%20cybersecurity%20aesthetic%2C%20clean%20and%20modern%20visualization&width=800&height=480&seq=article-security&orientation=landscape',
  },
];

export const faqItems = [
  {
    question: '2pg·com 如何注册新账号？',
    answer: '您可以通过手机号或邮箱进行注册。在首页点击"立即注册"按钮，输入您的手机号或邮箱地址，设置登录密码，接收并输入验证码后即可完成注册。整个流程约需30秒，方便快捷。',
  },
  {
    question: '注册后可以享受哪些新人福利？',
    answer: '新用户注册成功后，可立即领取专属新人礼包，包含首充优惠券、免费游戏次数、以及VIP体验资格。此外，完成实名认证还可获得额外的安全奖励金。',
  },
  {
    question: '平台支持哪些登录方式？',
    answer: '2pg·com 支持手机号登录、邮箱登录以及账号密码登录三种方式。老用户可以选择"记住密码"功能，下次访问时实现一键快速登录。所有登录方式均经过安全加密保护。',
  },
  {
    question: '如何保障我的账户安全？',
    answer: '平台采用256位SSL/TLS加密传输、多重身份验证、异常登录检测、以及资金独立托管等多重安全防护措施。建议您设置强密码并定期更换，同时开启登录保护功能以增强账户安全性。',
  },
  {
    question: '忘记密码如何找回？',
    answer: '在登录页面点击"忘记密码"，输入您注册时使用的手机号或邮箱，系统将发送验证码。验证通过后即可重新设置新密码。整个找回流程安全便捷，确保只有账户持有者能够重置密码。',
  },
  {
    question: '平台支持哪些设备访问？',
    answer: '2pg·com 全面支持PC端网页、移动端浏览器、以及iOS和Android客户端访问。您可以在任意设备上登录同一账号，游戏进度和账户数据实时同步，随时随地畅享游戏乐趣。',
  },
];